import { TockCookieName } from '@tock/shared/constants/browser-storage/TockCookies';
import { appendCookieSuffixes, setCookie } from '@tock/shared/utils/cookieUtils';
import env from '@tock/shared/utils/env';

export function getPatronLocationCookieName(domain: string) {
  const environmentName = env.get(domain);
  return appendCookieSuffixes(TockCookieName.GEO, {
    envSuffix: environmentName,
  });
}

export function setPatronLocationCookie(
  domain: string,
  cookieValue: string | number,
  expiration: number
) {
  setCookie(TockCookieName.GEO, cookieValue, {
    expirationFromNow: expiration,
    suffixOptions: {
      envSuffix: env.get(domain),
    },
  });
}

export function getSelectedLatLngCookieName(domain: string) {
  const environmentName = env.get(domain);
  return appendCookieSuffixes(TockCookieName.LAT_LNG, { envSuffix: environmentName });
}

export function setSelectedLatLngCookie(
  domain: string,
  cookieValue: string | number,
  expiration: number
) {
  setCookie(TockCookieName.LAT_LNG, cookieValue, {
    expirationFromNow: expiration,
    suffixOptions: {
      envSuffix: env.get(domain),
    },
  });
}
